import { render, staticRenderFns } from "./import-settings.vue?vue&type=template&id=ddcccb08"
import script from "./import-settings.vue?vue&type=script&lang=js"
export * from "./import-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports